/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 16:27:53
 * @LastEditors: caiqin.xie
 * @message: 门店-体验店
 */
import React from "react";
import ShopItem from "../ShopItem";
import styles from "../../index.module.scss";
import { getFileExtension } from '@/common/untils'
import LazyMedia from "@/components/LazyMedia";
import { IShop } from "@/common/types";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface IProps {
  experienceList: IShop[];
  ctry: string;
  words: Record<string, string>;
}

const ExperienceShop = (props:IProps) => {
  const { ctry, words, experienceList } = props

  return (
    <>
      {experienceList && experienceList.length > 0 && (
        <section className={styles['experience-shop']}>
          <h2>{words?.shop_experience_title}</h2>
          {/* Experience Shop in United */}
          <NoSSR>
            <CustomSwiper
              swiperWrapClass={styles['custom-swiper-wrap']}
              swiperSlideClass={styles['custom-swiper-slider']}>
              {experienceList.map((shop: IShop, index) => (
                <div className={styles['swiper-slide']} key={shop.id}>
                  <div className={styles['experience-store']}>
                    <div className={styles['experience-store-img']}>
                      {shop.images?.length > 0 && (
                        getFileExtension(shop.images[0].url) === 'mp4'
                        ? <LazyMedia LazyClassName='full-wh' type="video" loop autoPlay preload="auto" playsInline muted src={shop.images[0]?.url}></LazyMedia>
                        : <LazyMedia LazyClassName='full-wh' type="image" src={shop.images[0]?.url} alt={shop.images[0]?.alt} />
                      )}
                    </div>
                    <div className={styles['experience-store-info']}>
                      <ShopItem shopData={shop} className={styles['store-padding']}></ShopItem>
                    </div>
                  </div>
                </div>
              ))}
            </CustomSwiper>
          </NoSSR>
        </section>
      )}
    </>

  )
}
export default ExperienceShop
